export enum FeatureType {
  Home = 'Home',
  Juicebox = 'Juicebox',
  ContentCalendar = 'ContentCalendar',
  Trends = 'Trends',
  Tasks = 'Tasks',
  SocialListening = 'SocialListening',
  Inbox = 'Inbox',
}
